export const FALLBACK_CONTACT = "this contact";
export const FALLBACK_CONVERSATION = "this conversation";